export default [
  {
    path: '/app/notifications',
    name: 'Notifications',
    component: () => import('@/views/Notifications/Index.vue'),
    meta: {
      pageTitle: 'Duyurular',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'NOTIFICATION_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/notifications/add',
    name: 'NotificationAdd',
    component: () => import('@/views/Notifications/Add.vue'),
    meta: {
      pageTitle: 'Duyurular',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/notifications',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'NOTIFICATION_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/notifications/edit/:id',
    name: 'NotificationEdit',
    component: () => import('@/views/Notifications/Edit.vue'),
    meta: {
      pageTitle: 'Duyurular',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/notifications',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'NOTIFICATION_EDIT',
      action: 'read',
    },
  },
]
